/*
PM 2021-07-29
KONCEPCJA KOMPONENTU
================

Komponent kontener dla komponentu mapy ./Map
Opis propsow podawanych do dziecka mozna zobaczyc w interfejsie MapProps w komponencie ./Map

================

Funkcja getIcon zwraca pineskę odpowiedniego koloru na podstawie koloru (webSerwis /mapy/dajMapaObiekty lub /mapy/dajMapaObiekty1, zależnie od projektu)
Warianty takie jak w redmine brane z ./mapData

================
importowane komponenty:
import Map from './Map';

*/

import * as React from 'react';

import {
    getIcon, tiles
} from './mapData';

import Map from './Map';

import { connect } from 'react-redux';

import { AppState, store, Actions } from '../../appredux';
import CONFIG from '../../cfg/config';
import { sendErrorLog } from '../common/helpers';
import { Info } from '../../api';

//PM 2021-11-30
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface MapContainerProps {
    contact: Info,
    mapaGps: string,
}

//PM 2021-10-19
//tileErrors: number[],
//tileName: string,
interface MapContainerState {
    tooltip: string, //opis przy pinesce
    tileErrors: string[],
    tileName: string,
}

//komponent zarządzający stanem mapy
//przekazuje stan i funkcje jako propsy do komponentu Map.tsx
class MapContainer extends React.Component<MapContainerProps, MapContainerState>  {

    //PM 2021-10-19
    //tileErrors: [],
    //tileId: 1,
    constructor(props: MapContainerProps) {
        super(props, {});

        let text = CONFIG.hotelID.split(" ").map((current: string) => current.charAt(0).toUpperCase() + current.slice(1).toLowerCase()).join(" ")
        text = text.split("-").map((current: string) => current.charAt(0).toUpperCase() + current.slice(1)).join("-")

        this.state = {
            tooltip: text,
            tileErrors: [],
            tileName: tiles[1].name,
        }
        store.dispatch(Actions.pageState.addFcmLogMessage("okno glowne mapa", 0))
        sendErrorLog("1", "1", 'okno glowne mapa')
    }

    //PM 2021-10-19
    addTileError = async (aName: string) => {
        const tileErrors = this.state.tileErrors

        tileErrors.push(aName)
        this.setState({ ...this.state, tileErrors: tileErrors })
        store.dispatch(Actions.pageState.addFcmLogMessage("blad mapy", 2))
        await sendErrorLog("0", "-1", 'błąd mapy')
    }

    //PM 2021-10-19
    setTileName = async (aName: string) => {
        this.setState({ ...this.state, tileName: aName })
    }

    //głowna pętla
    //PM 2021-11-30
    //obsługa braku wspolrzednych do mapy
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    render = () => {
        const wspolrzedne = this.props.mapaGps.split(' ');
        let latNumber = 0
        let lngNumber = 0

        if (wspolrzedne.length === 2) {
            let lat = wspolrzedne[0].includes('N') || wspolrzedne[0].includes('S') ? wspolrzedne[0] : wspolrzedne[1];
            let lng = wspolrzedne[1].includes('E') || wspolrzedne[1].includes('W') ? wspolrzedne[1] : wspolrzedne[0];
            lat = lat.substring(0, lat.length - (lat.includes(',') ? 2 : 1));
            lng = lng.substring(0, lng.length - (lng.includes(',') ? 2 : 1));
            latNumber = Number(lat);
            lngNumber = Number(lng);
        }
        else {
            latNumber = 50.05394;
            lngNumber = 19.93560;
        }

        const promien = 0.0045;

        //vscTest
        //console.log(latNumber, lngNumber)

        return (
            <Map
                getIcon={getIcon} //pobieranie koloru pineski
                lat={latNumber}   //szer. geogr.
                lng={lngNumber}   //dl. geogr.
                bounds={[         //początkowe granice mapy
                    [latNumber + promien, lngNumber - promien],
                    [latNumber - promien, lngNumber + promien],
                ]}
                tooltip={this.state.tooltip} //opis przy pinesce
                addTileError={this.addTileError}
                setTileName={this.setTileName}
                tileErrors={this.state.tileErrors}
                tileName={this.state.tileName}
            />
        );
    }

}

const mapStateToProps = (state: AppState) => ({
    contact: state.pageState.contact,
    mapaGps: state.pageState.mapaGps
});

export default connect(mapStateToProps)(MapContainer);